const actions = {
    GET_DATA: "contacts/GET_DATA",
    SET_DATA: "contacts/SET_DATA",

    SET_INITIAL_CONTACTS: "contacts/SET_INITIAL_CONTACTS"

};

export default actions;